export const environment = {
  production: false,
  apiUrl: 'https://api-dev.djmixinglab.com/api',
  apiParseUrl: 'https://api-djmixinglab-dev-9ff2a7f1a3a2.herokuapp.com/api',
};
